<template>
  <div class="faq-accordion critical-component-clear container grid">
    <div
      class="
        faq-accordion__header
        col
        xs-span
        l3-10
        text-center
      "
    >
      <div class="faq-accordion__logo">
        <responsive-image
          :image="liquid.logo"
          :lazyload="false"
          ratio="1:1"
        />
      </div>

      <h2
        :id="`section-title-${liquid.sectionId}`"
        class="
          faq-accordion__title
          text-heading-l
          text-heading-xl-desktop"
        v-text="liquid.sectionTitle"
      />
    </div>

    <div class="faq-accordion__content col xs-span l3-10">
      <accordion-items
        v-slot="{item}"
        :items="accordions"
        title-class="accordion-item__button"
        label-class="text-heading-s text-heading-l-desktop"
      >
        <div
          v-if="item"
          class="faq-accordion__rte-content"
          v-html="renderAnswer(item)"
        />
      </accordion-items>

      <div
        v-if="liquid.cta"
        class="text-center"
      >
        <btn
          class="faq-accordion__cta"
          class-label="text-other-button-l"
          modifiers="text"
          :label="liquid.ctaLabel"
          :url="liquid.cta"
          show-icon="true"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: FAQ accordion (faq-accordion)
 * -----------------------------------------------------------------------------
 * Expandable text section to display frequently asked questions.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {String} liquid.sectionTitle - Section setting title.
 * @param {Array} blocks - Section setting blocks.
 *
 */
import AccordionItems from '~global/accordion/accordion-items'
import ResponsiveImage from '~global/images/responsive-image'
import Btn from '~global/btn/btn'

export default {
  name: 'FaqAccordion',

  components: {
    AccordionItems,
    ResponsiveImage,
    Btn,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        sectionTitle: '',
      }),
    },
    blocks: {
      type: Array,
      default: () => [
        {
          id: '',
          title: '',
          answer: '',
        },
      ],
    },
    metaFaqs: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      accordions: [],
    }
  },

  mounted() {
    if (this.metaFaqs.length > 0) {
      this.accordions = this.metaFaqs.map(faq => {
        return {
          active: false,
          ...faq,
        }
      })
      return
    }

    this.accordions = this.blocks.map((block) => {
      return {
        active: false,
        ...block,
      }
    })
  },

  methods: {

    /**
     * Check if an accordion is active.
     * @param {Number} index - Index of an accordion.
     */
    isActive(index) {
      return this.accordions[index].active
    },

    /**
     * Toggle active accordion.
     * @param {Number} targetIndex -  Index of an accordion.
     */
    toggleAccordion(targetIndex) {
      if (this.isActive(targetIndex)) {
        this.accordions[targetIndex].active = false
        return
      }

      this.accordions.forEach((accordion, index) => {
        accordion.active = targetIndex === index
      })
    },

    /**
     * Get Answer from block
     * @param {Object} item -  question item.
     */
    renderAnswer(item) {
      if (!item) {
        return ''
      }

      return item.answer
    },
  },
}
</script>

<style lang="scss">
@import './faq-accordion';
</style>
